<app-breadcrumb *ngIf="!user" master="Administracja" parentName="Użytkownicy" name="Dodaj"></app-breadcrumb>
<div class="user-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="userForm">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!userForm.valid || processingRequest "
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" [fxFlex]="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Typ użytkownika</h3>
            </div>
            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict fxFlex="100" [label]="'Uprawnienia'"
                          [dictType]="'user_roles'"
                          [control]="roleControl"
                          [required]="false"
                          [returnKey]="true"
                          [multiple]="false"></app-dict>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" *ngIf="roleControl.value" >
    <div fxLayout="column" [fxFlex]="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane użytkownika</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="50"  *ngIf="roleControl.value!=='ROLE_USER'">
                <mat-slide-toggle color="accent" [formControl]="partnerToggleControl" >
                  Partner
                </mat-slide-toggle>
              </div>
              <div fxFlex="50" *ngIf="roleControl.value!=='ROLE_USER'">
                <mat-slide-toggle color="accent" [formControl]="ofwcaToggleControl" >
                  Ofwca
                </mat-slide-toggle>
              </div>
            </div>
            <ng-container *ngIf="user">
              <div fxLayout="row" fxLayoutGap="15px" style="padding-bottom: 1.25em;">

                <div fxFlex="100" *ngIf="roleControl.value!=='ROLE_ASF360'">
                  <app-detail header="Nazwa" [value]="userObject.username"></app-detail>
                </div>

                <mat-form-field fxFlex="100" *ngIf="roleControl.value==='ROLE_ASF360'">
                  <mat-label>Nazwa</mat-label>
                  <input matInput formControlName="username" [required]="true">
                  <mat-error *ngIf="userForm.get('username').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>

              </div>
            </ng-container>

            <ng-container  *ngIf="partnerToggleControl.value" >
              <div fxLayout="row" fxLayoutGap="15px">
              <app-dict-partners
                fxFlex="100" label="Partner"
                [control]="partnerControl"
                (selectedPartner)="partnerChanged($event)"
                [required]="partnerToggleControl.value"
              ></app-dict-partners>
              </div>
            </ng-container>

            <ng-container *ngIf="ofwcaToggleControl.value" >
              <div fxLayout="row" fxLayoutGap="15px">
                <app-dict-ofwcas
                  fxFlex="100" label="OFWCA"
                  [control]="ofwcaControl"
                  (selectedOfwca)="ofwcaChanged($event)"
                  [required]="ofwcaToggleControl.value"
                ></app-dict-ofwcas>

              </div>
            </ng-container>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf=" roleControl.value!=='ROLE_ASF360'||( roleControl.value==='ROLE_ASF360' && (partnerToggleControl.value || ofwcaToggleControl.value) )">
              <mat-form-field fxFlex="50">
                <mat-label>Imię</mat-label>
                <input matInput placeholder="Jan" formControlName="firstName" [required]="true">
                <mat-error *ngIf="userForm.get('firstName').hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>

              <mat-form-field fxFlex="50">
                <mat-label>Nazwisko</mat-label>
                <input matInput placeholder="Kowalski" formControlName="lastName" [required]="true">
                <mat-error *ngIf="userForm.get('lastName').hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf=" roleControl.value!=='ROLE_ASF360'||( roleControl.value==='ROLE_ASF360' && (partnerToggleControl.value || ofwcaToggleControl.value) )">
              <mat-form-field fxFlex="50">
                <mat-label>Numer telefonu</mat-label>
                <input matInput placeholder="+48500200300" formControlName="phoneNumber" [required]="true" prefix="+48" mask=" 000 000 000">
                <mat-error *ngIf="userForm.get('phoneNumber').hasError('required')">To pole jest wymagane</mat-error>
                <mat-error *ngIf="userForm.get('phoneNumber').hasError('invalidPhoneNumber')">Podaj prawidłowy numer telefonu</mat-error>
              </mat-form-field>

              <mat-form-field fxFlex="50">
                <mat-label>Email</mat-label>
                <input matInput placeholder="adres@test.pl" formControlName="email" [required]="true">
                <mat-error *ngIf="userForm.get('email').hasError('required')">To pole jest wymagane</mat-error>
                <mat-error *ngIf="userForm.get('email').hasError('invalidEmailAddress')">Podaj prawidłowy adres email</mat-error>
                <mat-error *ngIf="userForm.get('email').hasError('backendError')">{{formErrors.email}}</mat-error>
              </mat-form-field>
            </div>




            <div fxLayout="row" fxLayoutGap="15px" *ngIf=" roleControl.value!=='ROLE_ASF360'||( roleControl.value==='ROLE_ASF360' && (partnerToggleControl.value || ofwcaToggleControl.value) )">
              <div [fxFlex]="'50'">
                <mat-slide-toggle class="slide-padding" formControlName="active" color="accent">Aktywny</mat-slide-toggle>
              </div>

              <div [fxFlex]=" '50'">
                <mat-slide-toggle class="slide-padding" formControlName="individualPermissions" color="accent">Uprawnienia Indywidualne</mat-slide-toggle>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px"  *ngIf=" roleControl.value!=='ROLE_ASF360'||( roleControl.value==='ROLE_ASF360' && (partnerToggleControl.value || ofwcaToggleControl.value) )">
              <div [fxFlex]="'50'" *ngIf="user && (userPermissions | async).user.admin_root">
              <mat-slide-toggle class="slide-padding" formControlName="googleAuthenticatorEnabled" color="accent">Google Authenticator 2FA</mat-slide-toggle>
              </div>
              <div [fxFlex]="'50'"   *ngIf=" roleControl.value!=='ROLE_ASF360' &&  user">
                <mat-slide-toggle class="slide-padding" formControlName="employeeList360" color="accent"> Widoczny na liście kontaktów</mat-slide-toggle>
              </div>
<!--              <div fxFlex="50">-->
<!--                <mat-slide-toggle  class="slide-padding" [formControl]="activeASF360Control" color="accent">Dostęp do ASF 360</mat-slide-toggle>-->
<!--              </div>-->
            </div>
            <div fxLayout="row" fxLayoutGap="15px"  >
              <div >
                <mat-slide-toggle class="slide-padding" formControlName="employee" color="accent">Pracownik</mat-slide-toggle>
              </div>
            </div>



          </mat-card>
        </div>
      </div>
    </div>


    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px"  *ngIf=" roleControl.value!=='ROLE_ASF360'||( roleControl.value==='ROLE_ASF360' && (partnerToggleControl.value || ofwcaToggleControl.value) )">


      <div fxLayout="row" fxFlex.lt-md="100%"  >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Zakres danych ASF24</h3>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <app-dict-departments
                [fxFlex]="'100'"
                [label]="'Dział'"
                [control]="departmentControl"
                [required]="departmentsRequired"></app-dict-departments>


            </div>


            <div fxLayout="row" fxLayoutGap="15px"   *ngIf="roleControl.value!=='ROLE_ASF360'">
              <app-dict-regionals fxFlex="100" [label]="'Regionalny'"
                                  [control]="regionalIdControl" [required]="false"></app-dict-regionals>
            </div>



            <div fxLayout="row" *ngIf="roleControl.value!=='ROLE_ASF360'">
              <div fxFlex="100">
                <app-dict fxFlex="100" [label]="'Tagi'" [dictType]="'partner_tags'"
                          [control]="partnerTagsControl" [required]="false" [multiple]="true"></app-dict>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="roleControl.value!=='ROLE_USER'" >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Zakres danych ASF360</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
                <app-dict-permission-tags
                  fxFlex="100"
                  [label]="'Grupy uprawnień'"
                  [required]="false"
                  [multiple]="true"
                  [formControl]="permissionTagControl"
                ></app-dict-permission-tags>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" >
              <app-dict-dobry-agent-partners
                fxFlex="100"
                [label]="'Partnerzy dobry-agent.pl'"
                [required]="false"
                [multiple]="true"
                [formControl]="dobryAgentPartnerControl"
              >
              </app-dict-dobry-agent-partners>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="roleControl.value === 'ROLE_ADMIN' || roleControl.value === 'ROLE_USER'" >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Konfiguracja kontaktu ASF360</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <mat-form-field fxFlex="100">
                <input matInput placeholder="Stanowisko" formControlName="position" [required]="false">
              </mat-form-field>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <mat-form-field fxFlex="100">
                <mat-label>Dział 360</mat-label>
                <input matInput placeholder="Dział 360" formControlName="department360" [required]="false">
              </mat-form-field>
            </div>

            <div fxLayout="row" *ngIf="roleControl.value!=='ROLE_ASF360'">
              <div fxFlex="100">
<!--                <app-dict fxFlex="100" [label]="'Tagi360'" [dictType]="'asf_360_tags'"-->
<!--                          [control]="asf360TagsControl" [required]="false" [multiple]="true"></app-dict>-->
                <app-dynamic-dict fxFlex="100"
                          [label]="'Tagi 360'"
                [dictType]="DYNAMIC_DICTIONARY_ASF360"  [control]="asf360TagsControl"
                 [required]="false" [multiple]="true"
                >
                </app-dynamic-dict>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100" fxLayout="column">
                <div fxFlex="none">
                  <p class="text-md text-gray">Opis stanowiska</p>
                </div>
                <angular-editor
                  fxFlex="100"
                  [config]="editorConfig"
                  [formControl]="positionDecriptionControl"
                  [required]="false"
                  (paste)="onPaste($event, true)">
                </angular-editor>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>
  </div>


  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!userForm.valid  || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
